import { XMarkIcon } from "@heroicons/react/20/solid";
import { addYears, format, subYears, parse } from "date-fns";
import { merge } from "lodash";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/noteActions";
import { handleRawDate } from "../common/DateComponents";

const NoteModal = ({ modalStatus, item, closeModal, saveNote, disabled, saving }) => {
	const [data, setData] = useState({});
	const updateField = (field, value) => {
		if (!field) return;
		const newData = merge(data, { ...(typeof field == "object" ? field : { [field]: value }) });
		setData({ ...newData });
	};

	useEffect(() => {
		if (Object.keys({ ...item })?.length === 0) setData({});
		else setData({ ...item });
	}, [item?.id]);

	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		saveNote(data);
	};

	if (!modalStatus) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Note Details</h3>
						</div>

						<div className="block-content">
							<form onSubmit={onSubmit}>
								<div className="col-xs-12">
									<label htmlFor="note">Note*</label>
									<textarea
										className="form-control form-input"
										name="note"
										id="note"
										style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
										value={item?.note}
										onChange={(e) => updateField(e.target.name, e.target.value)}
										required="required"
										disabled={disabled}
									/>
								</div>
								<div className="clearfix" />

								<div
									className="col-xs-12 pl-0"
									style={{ marginTop: "2rem" }}
								>
									<div className="col-xs-9">
										<div className="form-material">
											<label className="css-input switch switch-sm switch-success">
												<input
													type="checkbox"
													name="showInPayroll"
													id="showInPayroll"
													checked={item?.showInPayroll}
													onClick={(e) => updateField(e.target.name, !data[e.target.name])}
												/>
												<span />
												<label style={{ marginBottom: 0 }}>Notify in Next Payroll</label>
											</label>
										</div>
									</div>
									{data?.showInPayroll ? (
										<>
											<div className="col-xs-3 pr-0">
												<div className="form-material">
													<label>Reminder Date</label>
													<DatePicker
														autoComplete="off"
														dateFormat="dd MMM yyyy"
														minDate={subYears(new Date(), 30)}
														maxDate={addYears(new Date(), 10)}
														required={true}
														className="form-control"
														onChange={(date) => {
															updateField(
																"notificationDate",
																date ? format(date, "yyyy-MM-dd") : undefined,
															);
														}}
														onChangeRaw={(e) => {
															handleRawDate(e.target.value, (date) => {
																updateField(
																	"notificationDate",
																	date ? format(date, "yyyy-MM-dd") : undefined,
																);
															});
														}}
														strictParsing
														selected={
															data.notificationDate &&
															parse(data.notificationDate, "yyyy-MM-dd", new Date())
														}
													/>
												</div>
											</div>
										</>
									) : null}
								</div>
								<div className="clearfix" />
								<div className="block buttons mx-6 mt-8">
									{
										<button
											className="btn btn-success pull-right"
											type="submit"
											disabled={disabled || saving}
										>
											{saving ? "Saving Note..." : `${item?.id ? "Update" : "Add"} Note`}
										</button>
									}
								</div>
								<div className="clearfix" />
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		modalStatus: !!state.notes?.detailView,
		item: state.notes?.detailView,
		saving: state.notes?.saving,
		disabled: state?.permissions?.my?.permissions?.people == "Read",
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: (item) => dispatch(ACTIONS.showNoteDetail({ show: false })),
	saveNote: (item) => dispatch(ACTIONS.saveNote(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoteModal);
